import React from 'react';
/* eslint-disable import/no-extraneous-dependencies */
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import SvgCaretDown from '@digital-hig/icon/lib/build/ui-controls/caret-down';
import Typography from '@digital-hig/typography';
import { useTranslation } from 'react-i18next';
import TermsOfUseRootElement from './style';

const TermsOfUse = () => {
  const { t } = useTranslation();
  return (
    <TermsOfUseRootElement>
      <Box className="page-container">
        <Accordion className="accordion-list">
          <AccordionSummary data-wat-loc="subfooter" data-wat-val="partner finder terms of use" className="accordion-heading">
            <Typography variant="headline-smaller">
              {t('Partner Finder Terms of Use')}
            </Typography>
            <SvgCaretDown width="12px" />
          </AccordionSummary>
          <AccordionDetails className="accordion-content">
            <Typography>
              {t('By accessing and using Partner Finder, you acknowledge and agree to the following Additional Terms as referenced in the')}
              &nbsp;
              <Link
                target="_blank"
                href="https://www.autodesk.com/company/legal-notices-trademarks/access-use/website-terms-of-use"
                data-wat-val="Website Terms of Use"
                data-wat-loc="subfooter"
              >
                {t('Website Terms of Use')}
              </Link>
              {t(': (i) Partner Finder may be modified, updated, interrupted, limited, suspended, or discontinued at any time without notice or liability; (ii) any query or request for information regarding a specific provider or provider services may be forwarded to that provider, however Autodesk in its discretion may retain a record to conduct business analytics to improve Partner Finder and other Autodesk products and services; (iii) Autodesk has no obligation to enforce any terms on your behalf against another user; and (iv) any feedback you provide in connection with a provider, including ratings or reviews, is a non-confidential “Submission” as defined in the')}
              &nbsp;
              <Link
                target="_blank"
                href="https://www.autodesk.com/company/legal-notices-trademarks/access-use/website-terms-of-use"
                data-wat-val="Website Terms of Use"
                data-wat-loc="subfooter"
              >
                {t('Website Terms of Use')}
              </Link>
              {t('. You are advised to conduct your own independent analysis and assessment of any information provided by or though Partner Finder, including whether a selected provider is appropriate for your particular circumstances. Without limiting the')}
              &nbsp;
              <Link
                target="_blank"
                href="https://www.autodesk.com/company/legal-notices-trademarks/access-use/website-terms-of-use"
                data-wat-val="Website Terms of Use"
                data-wat-loc="subfooter"
              >
                {t('Website Terms of Use')}
              </Link>
              {t(', Autodesk does not warrant, endorse, guarantee, or assume responsibility for any service advertised or offered by a provider through Partner Finder or any hyperlinked website or service. Autodesk is not liable for the content of this site, or for the consequences of any actions you may take based on information provided by, or through, this site. You release Autodesk and its affiliates and subsidiaries from all liability arising from your use of Partner Finder, including any hyperlinked website, service, or content.')}
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion className="accordion-list">
          <AccordionSummary data-wat-loc="subfooter" data-wat-val="translation disclaimer" className="accordion-heading">
            <Typography variant="headline-smaller">
              {t('Translation tool disclaimer')}
            </Typography>
            <SvgCaretDown width="12px" />
          </AccordionSummary>
          <AccordionDetails className="accordion-content">
            <Typography>
              {t('This page has been translated for your convenience using a machine translation service. Reasonable efforts have been made to provide an accurate translation; however, no automated translation is perfect nor is it intended to replace human translators. As a result, this translation may contain errors and inaccuracies. Autodesk provides no warranties, either express or implied, about the accuracy, reliability, or completeness of the machine translation and disclaims all liability for any losses or damages caused by, or resulting from your reliance on, this translation. The English version of this website is the official version.')}
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Box>
    </TermsOfUseRootElement>
  );
};

export default TermsOfUse;
